import { PaiLensData } from '@upright/ui/common/upright/core/impact-lenses/pais/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { CarouselContext, useCarouselContext } from '../../../impact-lens-profile/context';

export function usePaiLensContext() {
  const context = useCarouselContext();
  if (context.lensType === ImpactLensType.EU_PAIS) {
    const paiContext = context as CarouselContext<ImpactLensType.EU_PAIS>;
    const data: PaiLensData = paiContext.data;
    const selectionState = paiContext.selectionState;
    return {
      data,
      selectionState,
      setSelectionState: paiContext.setSelectionState,
    };
  }
  return undefined;
}
